import { render, staticRenderFns } from "./productDialog.vue?vue&type=template&id=c522dae8&scoped=true"
import script from "./productDialog.vue?vue&type=script&lang=ts"
export * from "./productDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c522dae8",
  null
  
)

export default component.exports